<template>
  <div
    id="line"
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'line' }"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize14">
            <th
              v-for="head in HEAD"
              :key="head"
              class="column-title word_center"
            >
              {{ head }}
            </th>
            <th class="bulk-actions" colspan="7">
              <a class="antoo">
                Bulk Actions (
                <span class="action-cnt" />
                )
                <i class="fa fa-chevron-down" />
              </a>
            </th>
          </tr>
        </thead>
        <tbody v-if="vx_lineList">
          <template v-for="row in vx_lineList">
            <tr
              class="pointer fontSize14"
              :key="row.billInfo.orderId"
              style="text-align: center"
            >
              <td>{{ row.billInfo.orderId }}</td>
              <td>
                {{ getReservationTypeText(row.billInfo.reservationType) }}
              </td>
              <td>{{ row.driverInfo.callNumber }}</td>
              <td>{{ row.billInfo.reservationTime }}</td>
              <td>
                {{ noteProcess(row) }}
              </td>
              <td>{{ row.billInfo.onLocation }}</td>
              <td>{{ row.billInfo.offLocation }}</td>
              <td>
                {{ row.billInfo.passengerOnLacatioNote }}
              </td>
              <td>{{ row.billInfo.passengerNote }}</td>
              <td>{{ orderState(row) }}</td>
              <td>
                <button
                  @click="$emit('openModal', row.billInfo.orderId)"
                  class="mybtnstyle btn-danger"
                >
                  檢視
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { lineApp } from '@/constants/tableHead'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('reservation', {
      vx_activeTab: 'activeTab',
      vx_lineList: 'lineList',
    }),
  },
  methods: {
    orderState(row) {
      if (row.billInfo.result === null) {
        return '尚未有司機接單'
      } else if (row.billInfo.result === 1) {
        return '已載客'
      } else if (row.billInfo.driverCancel) {
        return '司機取消'
      } else if (row.billInfo.passengerCancel) {
        return '乘客取消'
      } else if (row.billInfo.result === 2) {
        return '完成'
      } else if (row.billInfo.result === 3) {
        return '未配對完'
      } else if (row.billInfo.result === 4) {
        return '等候乘客選擇司機'
      }
      return '已配對'
    },
    noteProcess(row) {
      if (
        row.billInfo.passengerName === null ||
        row.serviceInfo.name === null
      ) {
        return '---'
      } else {
        return (
          (row.serviceInfo.name ? row.serviceInfo.name : row.managerInfo.name) +
          '-' +
          row.billInfo.passengerName +
          '-' +
          row.billInfo.passengerPhone
        )
      }
    },
    getReservationTypeText(type) {
      if (type === 0) {
        return '一般預約'
      } else if (type === 1) {
        return 'LINE預約'
      } else if (type === 2) {
        return '機場接送'
      }
      return '未知類型'
    },
  },
  created() {
    this.HEAD = lineApp
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/reservation/components/LineApp.vue